import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { CalculatorTypeComponent } from './components/calculator-type/calculator-type.component';
import { PackSelectComponent } from './components/pack-select/pack-select.component';
import { CalculatorComponent } from './components/calculator/calculator.component';
import { ResultComponent } from './components/result/result.component';

const routes: Routes = [
  { path: '', component : CalculatorTypeComponent },
  { path: 'packs', component: PackSelectComponent },
  { path: 'calculator', component: CalculatorComponent },
  { path: 'result', component: ResultComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
